import React from "react";

const PortalContext = React.createContext(undefined);

export const usePortalContext = () => {
	const context = React.useContext(PortalContext);

	if (!context) throw new Error("Use within a sheet or modal");

	return context;
};

export default PortalContext;
